import * as React from 'react';

import { ModalWindow } from '@cian/ui-kit';
import loadable from '@loadable/component';
import { useToggleState } from '@cian/react-utils';
import { useSelector } from 'react-redux';

import { selectFilters } from '../../selectors/filters';
import { LoadableFallback } from '../../components/LoadableFallback';
import { GeoSwitcher } from '../../components/GeoSwitcher';
import { LoadableErrorBoundary } from '../../components/LoadableErrorBoundary';

const GeoSwitcherContainerInnerLoadable = loadable(() => import('./GeoSwitcherContainer'), {
  ssr: false,
  fallback: <LoadableFallback />,
});

interface IGeoSwitcherWrapperContainerProps {
  modalOpen?: boolean;
  canClose?: boolean;
  needReload?: boolean;
}

export const GeoSwitcherWrapperContainer: React.FC<IGeoSwitcherWrapperContainerProps> = ({
  modalOpen = false,
  needReload = false,
  canClose = true,
}) => {
  const { state: open, toggle: setOpen } = useToggleState(modalOpen);
  const filters = useSelector(selectFilters);
  const [displayName, setDisplayName] = React.useState<string>(filters.region.displayName);

  const handleGeoSwitcher = React.useCallback(() => {
    if (canClose) {
      setOpen();
    }
  }, [canClose, setOpen]);

  const handleDisplayName = (newName: string) => {
    setDisplayName(newName);
  };

  const retryLoadContent = React.useCallback(() => {
    GeoSwitcherContainerInnerLoadable.load();
  }, []);

  return (
    <div>
      <GeoSwitcher title={displayName} onClick={handleGeoSwitcher} />
      <ModalWindow
        open={open}
        hideCloseButton={!canClose}
        onClose={handleGeoSwitcher}
        header={null}
        content={
          <LoadableErrorBoundary onRetry={retryLoadContent}>
            <GeoSwitcherContainerInnerLoadable
              reload={needReload}
              onCloseGeoSwitcher={handleGeoSwitcher}
              onChangeDisplayName={handleDisplayName}
            />
          </LoadableErrorBoundary>
        }
        width={1179}
        size="M"
        fixed={false}
      />
    </div>
  );
};
